import { Badge, NotifyMeIcon, type BadgeProps } from '@buffer-mono/popcorn'
import { forwardRef } from 'react'
import styles from './PostNotifyBadge.module.css'

export const NotifyBadge = forwardRef<
  HTMLSpanElement,
  Pick<BadgeProps, 'size'>
>((props: Pick<BadgeProps, 'size'>, forwardRef): JSX.Element | null => {
  return (
    <Badge className={styles.notify} size="medium" {...props} ref={forwardRef}>
      <NotifyMeIcon />
      Notify
    </Badge>
  )
})

NotifyBadge.displayName = 'NotifyBadge'
